import React, { FC } from 'react';
import { Message } from '~/src/components/Popups/CallRequestByTheme/styled';
import OpenChat from '~/src/components/OpenChatLink';

interface IRenderMessageProps {
    isError: boolean,
    message: string | null | undefined
}

const RenderMessage: FC<IRenderMessageProps> = (
    {
        isError,
        message,
    },
) => {
    if (isError && message === undefined) {
        return <Message isError={isError}>
            Неизвестная ошибка, попробуйте оставить заявку позднее
            или напишите нам в&nbsp;<OpenChat/>.
        </Message>;
    }

    if (message == null) {
        return null;
    }

    return <Message isError={isError}>
        {message}
    </Message>;
};

export default RenderMessage;
